module.exports = __webpack_public_path__ + "img/about-m@1x.f7ee197f.webp";